import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useEstablishmentOrganizationCount(establishmentId) {
    const queryReturnValues = useQuery(
        // was ["menus"], which collided with useEstablishmentMenus - the two queries shared a cache
        // entry and overwrote each other's data
        ["organization-count", { establishmentId }],
        inventoryClient.getEstablishmentOrganizationCount,
        {
            staleTime: 1000 * 60 * 10
        }
    );

   return queryReturnValues;
}

export default useEstablishmentOrganizationCount;